var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeliveryGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon delivery black") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-delivery-black",
    fill: "#505050",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.6818182,18.2065217 L34.3636364,18.2065217 L34.3636364,11 L9.54545455,11 C7.59545455,11 6,12.6214674 6,14.6032609 L6,34.4211957 L9.54545455,34.4211957 C9.54545455,37.4119022 11.9209091,39.826087 14.8636364,39.826087 C17.8063636,39.826087 20.1818182,37.4119022 20.1818182,34.4211957 L30.8181818,34.4211957 C30.8181818,37.4119022 33.1936364,39.826087 36.1363636,39.826087 C39.0790909,39.826087 41.4545455,37.4119022 41.4545455,34.4211957 L45,34.4211957 L45,25.4130435 L39.6818182,18.2065217 Z M14.8636364,37.1236413 C13.3922727,37.1236413 12.2045455,35.9165489 12.2045455,34.4211957 C12.2045455,32.9258424 13.3922727,31.71875 14.8636364,31.71875 C16.335,31.71875 17.5227273,32.9258424 17.5227273,34.4211957 C17.5227273,35.9165489 16.335,37.1236413 14.8636364,37.1236413 Z M38.7954545,20.9089674 L42.27,25.4130435 L34.3636364,25.4130435 L34.3636364,20.9089674 L38.7954545,20.9089674 Z M36.1363636,37.1236413 C34.665,37.1236413 33.4772727,35.9165489 33.4772727,34.4211957 C33.4772727,32.9258424 34.665,31.71875 36.1363636,31.71875 C37.6077273,31.71875 38.7954545,32.9258424 38.7954545,34.4211957 C38.7954545,35.9165489 37.6077273,37.1236413 36.1363636,37.1236413 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveryGrey);
export default __webpack_public_path__ + "static/media/delivery-grey.ed74b853168505e42d87bd5f72929beb.svg";
export { ForwardRef as ReactComponent };